export default __webpack_public_path__ + "static/media/logo-close.58039b2b.svg";